window.Vue = require('vue');
require('./bootstrap');
window.$ = window.jQuery = require('jquery');

import { initCookies } from './cookies';
import { initScrollTo, _log, initBackToTop } from './util';
window._log = _log;
window.scrollTo = scrollTo;

import { vueHeader } from './header';
import { initWatch } from './single-watch';
import { initWatchFinder } from './watchfinder';
import { initCartElements } from './favorites';
import { initSliders } from './sliders';
import { initModules } from './modules';
import { initNearestRetailers } from './nearestRetailers';
import { initModals } from './modals';
import { initCards } from './cards';
import { initCounters } from './counters';
import { initBenefits } from './benefits';
import { initCareerFilters } from './career-filters';
import { initPrefillForms, strapsContactBtn, appointmentContactBtn } from './prefill-forms';
import { initDropdowns } from './dropdown';

document.addEventListener("DOMContentLoaded", function(event) {
  // _log("app.js: ready ...");
  window.eventBus = new Vue();
  vueHeader();
  //initCookies();
  initCartElements();
  initWatch();
  setTimeout (initSliders, 500);
  initScrollTo();
  initWatchFinder();
  initNearestRetailers();
  initModules();
  initModals();
  initCards();
  initCounters();
  initBenefits();
  initCareerFilters();
  initPrefillForms();
  strapsContactBtn();
  appointmentContactBtn();
  initDropdowns();
  //initBackToTop();
});